<template lang="html">
  <div>
    <h2>Teachers</h2>
    <ul>
      <li class="pl-subheading" v-for="user in users">
        <strong>Name</strong>: {{ user.name }}
        <br />
        <strong>Email</strong>: {{ user.email }}
      </li>
    </ul>
  </div>
</template>

<script>
  import adminServices from 'services/admin/adminServices';

  export default {
    data() {
      return {
        users: [],
      };
    },
    mounted() {
      adminServices
        .getUsersOfSchool(this.$route.params.schoolID)
        .then((res) => {
          this.users = res.data.users;
        })
        .catch(console.log);
    },
  };
</script>

<style lang="css"></style>



// WEBPACK FOOTER //
// manageTeachersInSchool.vue?7e25f2b4